import { setErrorMessage } from "../tools/errorhandling";
import { useEffect } from 'react';

const NotFound = () => {
    return (
        <div id="main">
        </div>
    )
}

export default NotFound